import './index.scss'

$('.download-dialog .close-icon').on('click',function(){
    $('.download-dialog').fadeOut(200)
    $('.root-mask').fadeOut(200)
})